import React from 'react';
import CatalogPagination from '../../../features/pagination';
import LeadRequestItem from '../../../entities/lead-request/ui/LeadRequestItem';
import CustomSelect from '../../../shared/ui/filter/LimitSelect';

const LeadRequestsList = ({ data, onRefresh }) => {
    return (
        <div className='admin-list'>
            <div className="admin-list__header">
                <p className="admin-list__header-info">
                    {data?.total || data?.items?.length || 0} Заявок
                </p>
                <div className="admin-list__header-func">
                    <CustomSelect options={[10, 20, 50]} />
                </div>
            </div>

            <div className="admin-list__content">
                <ul className="admin-list__content-titles team-grid">
                    <li>ПІБ / Контакт</li>
                    <li>Тип форми / Дата</li>
                    <li>Статус</li>
                    <li>Дія</li>
                </ul>
                <ul className="admin-list__content-items">
                    {data?.items?.length > 0 ? (
                        data.items.map((request) => (
                            <LeadRequestItem
                                key={request.id}
                                request={request}
                                onRefresh={onRefresh}
                            />
                        ))
                    ) : (
                        <li className="admin-list__empty">Дані відсутні</li>
                    )}
                </ul>
            </div>

            <div className="admin-list__pagination">
                <CatalogPagination data={data?.meta} />
            </div>
        </div>
    );
};

export default LeadRequestsList;
